import React, { useState } from "react";
import { addRental, getRentHistory } from "../../utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  Button,
  Drawer,
  Form,
  Input,
  Modal,
  Select,
  Table,
  Typography,
  message,
} from "antd";

const RentHistory = ({
  row,

  albums,
  musics,
}) => {
  const [visible, setVisible] = useState(false);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["user-rent-history", row._id, visible],
    queryFn: async () => await getRentHistory(row._id),
    enabled: visible,
  });
  console.log(musics);

  return (
    <div>
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        Rent History
      </Button>
      <Drawer
        title={"Rent History"}
        confirmLoading={isLoading}
        open={visible}
        onClose={() => setVisible(false)}
        footer={null}
        width={800}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}
          >
            Rent
          </Typography>
          <AddData
            refech={refetch}
            albums={albums}
            musics={musics}
            update={row}
          />
        </div>
        <Table
          dataSource={data?.rentedContent}
          columns={[
            {
              title: "Title",
              dataIndex: ["item", "name"],
            },
            {
              title: "Expire Date",
              dataIndex: "expireDate",
              render(value) {
                return (
                  <span>
                    {new Date(value).toLocaleDateString()}-{" "}
                    {new Date(value).toLocaleTimeString()}
                  </span>
                );
              },
            },
            {
              title: "Rented Date",
              dataIndex: "rentedDate",
              render(value) {
                return (
                  <span>
                    {new Date(value).toLocaleDateString()}-{" "}
                    {new Date(value).toLocaleTimeString()}
                  </span>
                );
              },
            },
          ]}
        />
      </Drawer>
    </div>
  );
};

export default RentHistory;

const AddData = ({
  refech,

  update,
  albums,
  musics,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) => await addRental(values),
    {
      onSuccess: () => {
        message.success(`Added`);
        //reset form
        form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        message.error(err?.response?.data?.message);
      },
    }
  );
  const type = Form.useWatch("type", form);
  console.log(albums);
  return (
    <div>
      {contextHolder}
      <Button
        type="primary"
        onClick={() => setVisible(true)}
        style={{
          width: "100%",
        }}
      >
        Add
      </Button>
      <Modal
        title={"Add Rent"}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 9 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          defaultValue={{
            type: "Music",
          }}
          onFinish={(values) => {
            console.log(values);

            mutate({
              ...values,
              userId: update?._id,
            });
          }}
        >
          {" "}
          <Form.Item label="Type" name="type" required>
            <Select>
              <Select.Option value="Music">Music</Select.Option>
              <Select.Option value="Album">Album</Select.Option>
            </Select>
          </Form.Item>
          {type === "Music" ? (
            <Form.Item label="Music" name="musicId" required>
              <Select placeholder="Select Music">
                {musics?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item label="Album" name="albumId" required>
              <Select placeholder="Select Album">
                {albums?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
